import React, {useEffect, useState} from 'react';
import {calculateIncome} from './income';
import './App.css';
const money = n => n.toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2});
export default function App() {
  const [mode,setMode] = useState('total');
  const [data,setData] = useState(null), [error,setError] = useState('');
  const [now,setNow] = useState(() => new Date());
  useEffect(() => {
    let active = true, busy = false;
    const controller = new AbortController();
    async function load() {
      if (busy) return;
      busy = true;
      try {
        const res = await fetch('/api/income',{cache:'no-store',signal:controller.signal});
        if (!res.ok) throw new Error('Abruf fehlgeschlagen');
        const next = await res.json();
        calculateIncome(next,new Date());
        if (active) {setData(next); setError('');}
      } catch (_) {if(active) setError('Aktuelle Daten nicht verfügbar. Ein vorhandener Stand bleibt sichtbar.');}
      finally {busy = false;}
    }
    load();
    const poll = setInterval(load,60000);
    const tick = setInterval(() => setNow(new Date()),1000);
    const visible = () => {if(document.visibilityState === 'visible') {setNow(new Date()); load();}};
    document.addEventListener('visibilitychange',visible);
    return () => {active=false; controller.abort(); clearInterval(poll); clearInterval(tick); document.removeEventListener('visibilitychange',visible);};
  },[]);
  let values = null, calculationError = '';
  if(data) {try {values=calculateIncome(data,now,mode);} catch(e) {calculationError=e.message;}}
  const cards = values ? [['Heute',values.today,values.daily],[values.monthName,values.mtd,values.monthly],['Seit Jahresbeginn',values.ytd,values.annual]] : [];
  return <main className="app"><h1>Income Clock</h1>
    <fieldset className="button-group"><legend>Einnahmen</legend>{[['total','Gesamt'],['active','Aktiv'],['passive','Passiv']].map(([value,label]) => <label key={value}><input type="radio" name="income-mode" checked={mode===value} onChange={() => setMode(value)}/>{label}</label>)}</fieldset>
    {(error || calculationError || data?.stale) && <p role="status" className="notice">{calculationError || error || 'Google Sheets derzeit nicht aktuell. Letzter gespeicherter Stand wird angezeigt.'}</p>}
    {!data && !error && <p role="status">Einnahmen werden geladen …</p>}
    {cards.map(([label,value,target]) => <section className="counter-block" key={label}><h2>{label}</h2>
      <div className="number-blocks" aria-label={money(value)+' Euro'}>{('€'+money(value)).split('').map((char,i) => /[0-9€]/.test(char) ? <span className="digit-block" key={i}><span className="flip" key={char}>{char}</span></span> : <span className="separator" key={i}>{char}</span>)}</div>
      <div className="progress-bar"><div className="progress" style={{width:Math.max(0,Math.min(100,target>0 ? value/target*100 : 0))+'%'}}/><span className="target">{money(target)} €</span></div>
    </section>)}
    {data && <p className="updated">Datenstand: {new Date(data.updatedAt).toLocaleString('de-DE',{timeZone:'Europe/Berlin'})} · Kalender: Berlin</p>}
  </main>;
}
